import {
  List,
  useTable,
  EditButton,
  DeleteButton,
  CreateButton,
} from '@refinedev/antd'
import { Table, Space, Tag } from 'antd'

export { default as CategoryCreatePage } from './create'
export { default as CategoryEditPage } from './edit'

interface CategoryRow {
  id: string
  name: string
  slug: string
  sortOrder: number
  active: boolean
  productCount?: number
}

export function CategoriesListPage() {
  const { tableProps } = useTable<CategoryRow>({
    resource: 'categories',
    syncWithLocation: true,
    sorters: { initial: [{ field: 'sortOrder', order: 'asc' }] },
  })

  return (
    <List headerButtons={<CreateButton>Dodaj kategoriju</CreateButton>}>
      <Table {...tableProps} rowKey="id">
        <Table.Column title="Redosled" dataIndex="sortOrder" width={100} sorter />
        <Table.Column title="Naziv" dataIndex="name" sorter />
        <Table.Column title="Slug" dataIndex="slug" />
        <Table.Column
          title="Proizvoda"
          dataIndex="productCount"
          render={(c?: number) => c ?? 0}
        />
        <Table.Column
          title="Aktivna"
          dataIndex="active"
          render={(active: boolean) => (active ? <Tag color="green">Da</Tag> : <Tag>Ne</Tag>)}
        />
        <Table.Column<CategoryRow>
          title="Akcije"
          dataIndex="actions"
          render={(_, record) => (
            <Space>
              <EditButton hideText size="small" recordItemId={record.id} />
              <DeleteButton hideText size="small" recordItemId={record.id} />
            </Space>
          )}
        />
      </Table>
    </List>
  )
}
